import { useFormik } from 'formik';
import { FunctionaryInfoProps } from './props';
import { initialValues, validationSchema } from './formData';
import { useEffect, useState } from 'react';
import { asyncGetParamsClassName } from '../../../../../../services/param.service';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';
import { asyncGetFunctionariesSwitchSelect } from '../../../../../../services/functionaries-switch.service';
import { formatFunctionaries } from '../../../../../../shared/utils/switch';
import { formatParams } from '../../../../../../shared/utils/params';
import { asyncGetTemplateByCode } from '../../../../../../services/template.service';
import { asyncGetFunctionaryByEmail } from '../../../../../../services/functionaries-switch.service';

export const useSwichFunctionaryInfo = ({
    data,
    onChangeData,
    onChangeFormik,
}: FunctionaryInfoProps) => {
    const [areas, setAreas] = useState<ISelect[]>([]);
    const [functionaries, setFunctionaries] = useState<any[]>([]);

    const onSubmit = (data: any) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('area', data?.area || '');
        formik?.setFieldValue('functionary', data?.functionary || '');
        formik?.setFieldValue('emailFunctionary', data?.emailFunctionary || '');
        formik?.setFieldValue(
            'functionaryExtension',
            data?.extFunctionary || ''
        );
        formik?.setFieldValue(
            'functionaryAttendedCall',
            data?.functionaryAttendedCall || ''
        );
        formik?.setFieldValue('templateEmail', data?.templateEmail || '');
    }, [data]);

    useEffect(() => {
        asyncGetParamsClassName(
            ParamEnum.FUNCTIONARIES_SWITCHBOARD_AREA,
            '',
            '',
            '',
            0,
            0,
            true
        ).then((res: ISelect[]) => {
            setAreas(formatParams(res));
        });
    }, []);

    useEffect(() => {
        if (formik.values.area) {
            asyncGetFunctionariesSwitchSelect({
                areaFunctionary: formik.values.area,
                active: true,
            }).then((res: any) => {
                setFunctionaries(formatFunctionaries(res.items));
            });
        }
    }, [formik.values.area]);

    useEffect(() => {
        const email = (formik.values.emailFunctionary || '').toString().trim();
        if (!email) return;
        asyncGetFunctionaryByEmail(email).then((res) => {
            if (!res) return;
            const areaId =
                typeof res.area === 'object' && res.area?.id
                    ? res.area.id
                    : res.area || '';
            if (areaId) {
                formik.setFieldValue('area', areaId);
                asyncGetFunctionariesSwitchSelect({
                    areaFunctionary: areaId,
                    active: true,
                }).then((r: any) =>
                    setFunctionaries(formatFunctionaries(r.items))
                );
            }
            const fn = res.functionary;
            if (fn?.id) {
                formik.setFieldValue('functionary', fn.id);
                formik.setFieldValue('emailFunctionary', fn.email || email);
                formik.setFieldValue(
                    'functionaryExtension',
                    fn.extension || ''
                );
            }
        });
    }, [formik.values.emailFunctionary]);

    useEffect(() => {
        if (formik.values.functionaryAttendedCall == 'si') {
            formik.setFieldValue('templateEmail', '');
            return;
        }
        asyncGetTemplateByCode(ParamEnum.SWITCH_FUNCTIONARY_ATENDED_CALL).then(
            (res) => {
                formik.setFieldValue(
                    'templateEmail',
                    data?.templateEmail || res?.body || ''
                );
            }
        );
    }, [formik.values.functionaryAttendedCall]); //

    return { formik, areas, functionaries };
};
